import React, { useState } from 'react';
import MeddiDiabetes from '../../../../Components/HealthPlan/Diabetes/MeddiDiabetes';
import {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import { HealthPlanCode } from '../../../../Enums/HealthPlanCode.enum';
import {
	HealthPlan,
	useLazyHealthPlansQuery,
} from '../../../../graphql/graphql';
import { useEffectAsync } from '../../../../helpers';
import { useAppContext } from '../../../../Services/AppContext';
import { HealthPlanContextProvider } from '../../../../Services/HealthPlanContext';
import { usePatientTreatmentContext } from './ContextProvider';
import PatientTreatmentPageWrapper from './PatientTreatmentPageWrapper';
import HealthPlanBabyWrapper from '../../../HealthPlan/Components/HealthPlanBaby/HealthPlanBabyWrapper';
import HealthPlanTherapistWrapper from '../../../HealthPlan/Components/HealthPlanTherapist/HealthPlanTherapistWrapper';
import Loading from '../../../../Components/Loading';
import DynamicHealthPlan from '../../../Dynamic/Components/DynamicHealthPlan/DynamicHealthPlan';
import MeddiDENT from '../../../DENT/Components/MeddiDENT/MeddiDENT';
import { InitialTabParams } from '../../Interfaces/InitialTabParams.interface';

interface Props {
	workplaceId: string;
	healthPlans: any;
	activeTabParams?: InitialTabParams;
}
const PatientTreatmentHealthPlan: React.FC<Props> = ({
	healthPlans,
	workplaceId,
	activeTabParams: activeTabParamsProp,
}) => {
	const { patientId } = usePatientTreatmentContext();
	const { activeTabParams: activeTabParamsContext } = useAppContext();
	const activeTabParams = activeTabParamsProp ?? activeTabParamsContext;
	const [steps, setSteps] = useState<NavigationStepperItemType[]>([]);
	const [firstPlan, setFirstPlan] = useState<HealthPlan | null>(null);
	const [isLoading, setIsLoading] = useState(false);

	const handleRefreshComponent = () => {
		setIsLoading(true);
		setIsLoading(false);
	};

	useEffectAsync(async () => {
		const tempSteps: NavigationStepperItemType[] = [];

		if (healthPlans.length) {
			setFirstPlan(healthPlans[0]);

			for (const healthPlan of healthPlans) {
				if (!healthPlan) {
					continue;
				}

				if (healthPlan.code === activeTabParams?.initialStepPath) {
					setFirstPlan(healthPlan);
				}

				switch (healthPlan.code) {
					case HealthPlanCode.DIABETES:
						tempSteps.push({
							name: healthPlan.name!,
							key: healthPlan.code,
							component: (params: NavigationStepperComponentParams) => (
								<HealthPlanContextProvider
									values={{
										healthPlan: { code: HealthPlanCode.DIABETES },
										setHealthPlan: () => {},
										healthPlanUser: undefined,
										setHealthPlanUser: () => {},
										healthPlanData: null,
										setHealthPlanData: () => {},
										activeHealthPlanUserItem: null,
										setActiveHealthPlanUserItem: () => {},
									}}>
									<PatientTreatmentPageWrapper patientId={patientId}>
										<MeddiDiabetes
											workplaceHealthPlanId={healthPlan.id}
											patientId={patientId}
											setIsLoading={params.setIsLoading}
											workplaceId={workplaceId}
										/>
									</PatientTreatmentPageWrapper>
								</HealthPlanContextProvider>
							),
						});
						break;
					case HealthPlanCode.BABY:
						tempSteps.push({
							name: healthPlan.name!,
							key: healthPlan.code,
							component: () => (
								<PatientTreatmentPageWrapper patientId={patientId}>
									<HealthPlanBabyWrapper
										patientId={patientId}
										workplaceId={workplaceId}
										onHealthPlanCreate={handleRefreshComponent}
									/>
								</PatientTreatmentPageWrapper>
							),
						});
						break;
					case HealthPlanCode.THERAPIST:
						tempSteps.push({
							name: healthPlan.name,
							key: healthPlan.code,
							component: () => (
								<HealthPlanTherapistWrapper patientId={patientId} />
							),
						});
						break;
					case HealthPlanCode.OBESITOLOGY_THERAPIST:
					case HealthPlanCode.OBESITOLOGY:
					case HealthPlanCode.KDAR:
						tempSteps.push({
							name: healthPlan.name,
							key: healthPlan.code,
							component: () => (
								<PatientTreatmentPageWrapper patientId={patientId}>
									<DynamicHealthPlan
										structure={healthPlan.structure}
										patientId={patientId}
										healthPlanCode={healthPlan.code}
										workplaceId={workplaceId}
									/>
								</PatientTreatmentPageWrapper>
							),
						});
						break;
					case HealthPlanCode.DENT:
						tempSteps.push({
							name: healthPlan.name,
							key: healthPlan.code,
							component: () => (
								<PatientTreatmentPageWrapper patientId={patientId}>
									<MeddiDENT
										patientId={patientId}
										onHealthPlanCreate={handleRefreshComponent}
									/>
								</PatientTreatmentPageWrapper>
							),
						});
						break;
				}
			}
		}

		setSteps(tempSteps);
	}, [isLoading, activeTabParams]);

	if (!steps.length) {
		return <></>;
	}
	if (isLoading) {
		return <Loading />;
	}
	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath={firstPlan?.code || ''}
				canSkip={true}
			/>
		</>
	);
};

export default PatientTreatmentHealthPlan;
